import React, { useEffect, useState } from 'react';
import './IntegrationBadges.css';
import { dedupFetch } from '../utils/dedupFetch';

// Mismo banner de integraciones que el topbar del Revenue Checkpoint
// (decision de Alejo 2026-07-19: ese diseño en todas las paginas).
// Reglas (identicas a RevenueCheckpoint.jsx):
// - Shopify SIEMPRE verde: los datos fluyen aunque la cuenta sea legacy sin
//   app instalada (nunca alarmar en rojo por lo no instalado).
// - Klaviyo solo se muestra cuando /klaviyo/status confirma connected:true.
// - Omnisend/CDP: apareceran cuando exista su endpoint de estado.

const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
const KLAVIYO_API_BASE = isLocalhost
  ? 'http://localhost:8000'
  : 'https://mi-chat-892931479853.us-central1.run.app';

const getCompanyId = (c) =>
  c?.CompanyId || c?.companyId || c?.company_id || c?.id ||
  localStorage.getItem('companyId') || localStorage.getItem('shopifyCompanyId') || '';

export default function IntegrationBadges({ companyInfo, token }) {
  const companyId = getCompanyId(companyInfo);
  const [klaviyoConnected, setKlaviyoConnected] = useState(null);

  useEffect(() => {
    if (!companyId || !token) return undefined;
    let cancelled = false;
    // dedupFetch: RevenueCheckpoint pide el mismo endpoint; colapsar si ambas
    // vistas montan en la misma rafaga inicial (no ocurre hoy porque son
    // vistas mutuamente excluyentes, pero evita duplicar si eso cambia).
    dedupFetch(`${KLAVIYO_API_BASE}/klaviyo/status?company=${encodeURIComponent(companyId)}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data) setKlaviyoConnected(Boolean(data.connected));
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [companyId, token]);

  return (
    <div className="ib-badges">
      <span className="ib-badge ib-badge-connected">● Shopify</span>
      {klaviyoConnected === true && (
        <span className="ib-badge ib-badge-connected">● Klaviyo</span>
      )}
    </div>
  );
}
